import { sxVariants } from '@/utils/combineSx';

const CARD_BORDER_RADIUS = '0.25rem' as const;

const cardVariants = sxVariants({
  base: theme => ({
    position: 'relative',
    backgroundColor: theme.palette.baseColors.white.c100,
    borderRadius: CARD_BORDER_RADIUS,
    padding: 'var(--padding)',
    '--transition-d-enter': '0.2s',
    '--transition-d-exit': '0.1s',
    // border: `1px solid ${theme.palette.baseColors.iceBlue.c50}`,

    '&:after': {
      position: 'absolute',
      content: '" "',
      inset: 0,
      borderRadius: CARD_BORDER_RADIUS,
      opacity: 0,
      zIndex: 1,
      boxShadow: '0 4px 16px rgba(0, 0, 0, 0.12), 0 2px 4px rgba(0, 0, 0, 0.06)',
    },

    '& > * ': {
      position: 'relative',
      zIndex: 10,
    },
  }),
  variants: {
    interactive: {
      true: {
        transformStyle: 'preserve-3d',
        transition: 'translate var(--transition-d-enter) var(--ease-exit)',
        '&:after': {
          transition: 'opacity var(--transition-d-enter) var(--ease-exit)',
        },

        '&:hover': {
          translate: '0 0 4px',
          transition: 'translate var(--transition-d-enter) var(--ease-enter)',

          '&:after': {
            opacity: 1,
            transition: 'opacity var(--transition-d-enter) var(--ease-enter)',
          },
        },
      },
      false: {},
    },
    padding: {
      none: {},
      standard: {
        '--padding': '1.5rem',
      },
      compact: {
        '--padding': '0.75rem 1.5rem',
      },
    },
    border: {
      true: theme => ({
        border: `1px solid ${theme.palette.baseColors.iceBlue.c100}`,
      }),
    },
  },
  defaultVariants: {
    interactive: false,
    padding: 'none',
  },
});

export { CARD_BORDER_RADIUS, cardVariants };
